import Actions from './components/actions';
import priceCalc  from './components/calc';
//import AOS from 'aos';
//import 'aos/dist/aos.css'; 
import Animation  from './components/animation';
import Sliders from './components/sliders';
import myParallax  from './components/parallax';
import './components/compare';

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import Headroom from "headroom.js";

var  header = document.querySelector("header");
var  headroom = new Headroom(header);
headroom.init();

Fancybox.bind("[data-fancybox]", {
    // Your custom options
});

new Actions().init();
new Sliders().init();
new priceCalc().init();
new myParallax().init();
new Animation().init();

// AOS.init({
//     duration: 2000,
//     once: true,
// });